import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

const selectLoanCicFeeReasonsV2 = createSelector(
  selectLoanApplication,
  ({ loanCicFeeReasonsV2 }) => loanCicFeeReasonsV2,
);

export const selectCicChangeReasons = createSelector(
  selectLoanCicFeeReasonsV2,
  ({ cicChangeReasons }) =>
    cicChangeReasons.reduce((acc, fee) => {
      acc[fee.feeTypeId] = {
        notes: fee.reasons.reduce((acc, reason) => {
          acc[reason.cicFeeReasonId] = reason.note;

          return acc;
        }, {}),
      };

      return acc;
    }, {}),
);

export const selectCureBaseline = createSelector(
  selectLoanCicFeeReasonsV2,
  ({ cureBaseline }) => cureBaseline,
);
